import { withAfterpayRadioProps } from 'viewModel/checkout/sections/payment/section/afterpayRadio/withAfterpayRadioProps';

import PaymentRadio from 'components/Checkout/Sections/Payment/Section/PaymentRadio';

export default withAfterpayRadioProps(PaymentRadio);
